import React from "react";
import { Form, DatePicker, Mentions } from 'antd';
import moment from 'moment';


const FormItem = Form.Item;

/**
 * A form that is used to search for a live schedule. It has two inputs, a dropdown to search for a schedule by date 
 and a date picker for the start date.
 */
class DetailedScheduleForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmDirty: false,
            autoCompleteResult: [],
        };
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
            }
        });
    };

    handleConfirmBlur = (e) => {
        const value = e.target.value;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    };

    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };

        return (

            <Form onSubmit={this.handleSubmit}>
                <FormItem
                    {...formItemLayout}
                >
                    <div style={{ marginTop: 10 }}>
                        <Mentions style={{ marginRight: 10, border: "none", width: 120 }} placeholder="Start Date" readOnly />
                        <DatePicker
                            onChange={this.props.handleStartDateChange}
                            value={this.props.detailedStartDate}
                            popupStyle={{ zIndex: 2000 }}
                        />
                    </div>
                </FormItem>

                <FormItem
                    {...formItemLayout}
                >
                    <div style={{ marginTop: 10 }}>
                        <Mentions style={{ marginRight: 10, border: "none", width: 120 }} placeholder="End Date" readOnly />
                        <DatePicker
                            onChange={this.props.handleEndDateChange}
                            value={this.props.detailedEndDate}
                            popupStyle={{ zIndex: 2000 }}
                        />
                    </div>
                </FormItem>
            </Form>
        );
    }
}

export const WrappedDetailedScheduleForm = Form.create()(DetailedScheduleForm);




// WEBPACK FOOTER //
// ./src/Components/Schedule/DetailedSchedule/DetailedScheduleForm.js